import React, { Component } from 'react';
import './App.css';
import { Grid, Row, Col } from 'react-bootstrap';
import ChatMessage from './ChatMessage';
import ChatBar from './ChatBar';

var socket = require('socket.io-client')('https://ec2-54-169-159-158.ap-southeast-1.compute.amazonaws.com:3000');

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { recieved: [] }
    this.showReceived = this.showReceived.bind(this);
  }
  componentDidMount() {
    let context = this;
    socket.emit('loggeduser', {username: localStorage.getItem('chat_token')});
    socket.on('chat message recieve', function(msg){
      console.log(msg);
      let currentMessage = context.state.recieved;
      currentMessage.push(msg.text);
      context.setState({
        recieved: currentMessage
      });
    });
  }
  showReceived() {
    return this.state.recieved.map(msg => 
      (<ChatMessage key={msg} message={msg}> {msg} </ChatMessage>)
    );
  }
  sendMessage(text) {
    let message = {
      to: {username: 'Taeyeon'},
      from: {username: localStorage.getItem('chat_token')},
      text: text
    };
    socket.emit('chat message send', message);
  }
  render() {
    return (
      <div>
          <Grid>
              <Col md={1} className="back"></Col>
              <Col md={3}>
                <Row>
                  <Col xs={12} md={12} className="title">
                    <img className="profile-image" src="icons/profilepic.png" width="40"/>
                    <span className="name">Margot Robbie</span>
                    <a href=""><img className="message-image" src="icons/message.png" width="25"/></a>
                  </Col>
                </Row>
                <Row className="rw-search">
                  <Col xs={12} md={12}>
                    <div className="search-container">
                      <img src="icons/search.png" width="25"/>
                      <input className="search" type="text" placeholder="search or start a new chat" />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} className="person-container">
                    <Col md={12} className="person">
                      <Col md={3}>
                        <img src="icons/profilepic.png" width="50" />
                      </Col>
                      <a href="">
                        <Col md={7}>
                          <span>Robert Johnson</span><br/>
                          <span>Hey how are ...</span>
                        </Col>
                      </a>
                      <Col md={2}>
                        <span>9:36 PM</span>
                      </Col>
                    </Col>
                    <Col md={12} className="person">
                      <Col md={3}>
                        <img src="icons/profilepic.png" width="50" />
                      </Col>
                      <a href="">
                        <Col md={7}>
                          <span>Robert Johnson</span><br/>
                          <span>Hey how are ...</span>
                        </Col>
                      </a>
                      <Col md={2}>
                        <span>9:36 PM</span>
                      </Col>
                    </Col>
                    <Col md={12} className="person">
                      <Col md={3}>
                        <img src="icons/profilepic.png" width="50" />
                      </Col>
                      <a href="">
                        <Col md={7}>
                          <span>Robert Johnson</span><br/>
                          <span>Hey how are ...</span>
                        </Col>
                      </a>
                      <Col md={2}>
                        <span>9:36 PM</span>
                      </Col>
                    </Col>
                  </Col>
                </Row>
              </Col>
              <Col md={7}>
                <Row>
                  <Col xs={12} md={12}>
                    <Col xs={12} md={12} className="title-chat">
                      <Col xs={12} md={1}>
                        <img className="profile-image" src="icons/profilepic.png" width="40"/>
                      </Col>  
                      <Col xs={12} md={7}>
                        <span className="name-chatter">Ben affleck</span>
                      </Col>
                      <Col xs={12} md={4}>
                      
                      </Col>
                    </Col>
                  </Col>
                </Row>
                <Row className="area">
                  { 
                    this.showReceived()
                  }
                </Row>
                <ChatBar trigger={this.sendMessage}/>
              </Col>
              <Col md={1} className="back"></Col>
          </Grid>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js